module.exports = __webpack_public_path__ + "img/crock.05db0fc3.jpg";